import React from 'react';
import CigeplanillasCard from './cigeplanillasCard';
import img1 from '../../../public/images/6-PLANILLAS-768x389.png';

import Button from '../Button';

const cigeplanillas = () => {
  return (
    <div className="min-h-screen container mx-auto flex flex-col items-center justify-center mt-16 mb-8 px-5 lg:px-0">
      <div className="w-full lg:w-3/4 space-y-8">
        <CigeplanillasCard
          img={img1}
          title="Gestion de Planillas"
          description=""
          items={[
            "Cálculo del proceso de planilla: CTS, gratificaciones, renta de 5ta categoría, utilidades y planillas.",
            "Generación de archivo para AFP Net y PLAME.",
            "Pago de remuneraciones por distintos bancos.",
            "Control de horario: marcados de hora para inicio y fin de jornada laboral.",
            "Emisión de boletas de pago y envío automático por correo electrónico a tus colaboradores.",
            "Emisión de contratos de trabajo.",
            "Certificados de trabajo y renta de 5ta. categoría.",
            "Generación automática de asientos de planilla al ERP CIGEPERU.",
            "Reportes dinamicos: por colaborador, por tipo de planilla, por control de horas y más."
          ]}
          reverse
        />
      </div>

      <Button title="Ver Todos los Servicios" />
    </div>
  );
};

export default cigeplanillas;
